<template>
  <action-dispatcher
    action="workout/getRecordedExercise"
    :parameters="$route.params.id"
    class="view-live container text-light py-5"
  >
    <router-link class="small text-secondary" :to="{ name: 'workout' }">
      <i class="fas fa-chevron-left" /> Seja forte
    </router-link>
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="d-flex justify-content-center">
          <div class="w-100">
            <video-player class="my-4" :lesson="{ stream_url: exercise.url }" />
          </div>
        </div>
        <h5>{{ exercise.title }}</h5>
        <div v-html="exercise.description" />
      </div>
    </div>
  </action-dispatcher>
</template>

<script>
import { mapState } from "vuex";
import VideoPlayer from "@/components/lesson/VideoPlayer";

export default {
  components: { VideoPlayer },
  computed: {
    ...mapState("workout", ["exercise"])
  }
};
</script>
